import React from "react"
import "./NewsListPage.scss"
import { Link } from "gatsby"
import moment from "moment"

import LearnMoreBtn from "../learn-more-btn/LearnMoreBtn"
import { getImageUrl } from "../../services/Utils"

const NewsListPage = ({ items, itemsInRow, learnMoreBtnText }) => {
  const configureItemsInTheRowAmount = itemsInRows => {
    if (itemsInRows === 2) {
      return "col-lg-6"
    } else if (itemsInRows === 4) {
      return "col-md-6 col-lg-3"
    }
  }

  return (
    <div className="news-list-wrapper projects-list row flex-wrap">
      {items && items.length
        ? items.map(item => {
            return (
              <div
                key={item.id}
                className={`projects-list__item d-flex flex-column justify-content-between ${configureItemsInTheRowAmount(
                  itemsInRow
                )} mt-3 mb-3 curs-P`}
              >
                <Link to={`/news/${item?.resolvedPath}`}>
                  <div
                    className="news-item-image mb-2"
                    style={{
                      minHeight: "315px",
                      backgroundImage: `url(${getImageUrl(item?.imageUrl)})`,
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      position: "relative",
                    }}
                  ></div>

                  <div className="title-description-wrapper">
                    <div className="description publish-date py-3">
                      {moment(item.dateTime).format("DD/MM/YYYY")}
                    </div>
                    <div className="title mb-2">{item?.title}</div>
                    <div
                      className="description mb-3"
                      dangerouslySetInnerHTML={{ __html: item?.description }}
                    />
                  </div>
                </Link>
                <div className="mb-4">
                  <LearnMoreBtn buttonLabel={learnMoreBtnText} />
                </div>
              </div>
            )
          })
        : null}
    </div>
  )
}

export default NewsListPage
